var audio_default = {
  "fontElementMap": "vF0Tc",
  "container": "MoB4x",
  "coverImageContainer": "OSjof",
  "customPlayer": "tJ8r2",
  "slim": "bT4YF",
  "playPauseButton": "MVDP4",
  "coverImage": "_7wM8I",
  "trackDetailsContainer": "nyGBf",
  "controlsContainer": "HNdf-",
  "controlsGroup": "_8HzDw",
  "sliderContainer": "bWvHP",
  "audioDuration": "c4N6u",
  "isLoading": "p1RGL",
  "audioDetails": "Pn40N",
  "authorName": "B1HlJ",
  "title": "H8P-8",
  "dropdownMenuWrapper": "EAxgX",
  "dropdownSelectedButton": "mBeeD",
  "dropdownContent": "w39xl",
  "dropdownContentWithIcon": "dTEnO",
  "audioLoader": "kqjZu"
};
export {
  audio_default as default
};
//# sourceMappingURL=audio-scss.js.map
